import packageJson from '../package.json';

export enum Environment {
  Local = "local",
  Dev = "dev",
  Prod = "prod",
}

const currentEnvironment: Environment =
  (process.env.REACT_APP_ENV as Environment) || Environment.Local;

const ENVS_BOUNCE_API = {
  [Environment.Local]: "http://localhost:8080",
  [Environment.Dev]: "https://api.dev.padelhouse.ro",
  [Environment.Prod]: "https://api.padelhouse.ro",
};

const basePath = (packageJson as { homepage?: string }).homepage ?? '';
const CONFIG = {
  BASE_PATH_URL: basePath,
  BOUNCE_API: ENVS_BOUNCE_API[currentEnvironment],
}

export { CONFIG }
